import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Invoice } from "@common/types/invoice";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Amount } from "@design-system/Amount/Amount";
import { useAccrualAwareTableMeta } from "@hooks/view/accrualAwareTableMeta";
import { getInvoicePaidAmount } from "@common/helpers/accrual/openAmount";
import { InvoicesViewCallbacks } from "../types";

export const PaidAmountCell = memo(
    ({ row, table }: CellContext<ViewTableFeatures, Invoice, number>) => {
        const invoice = row.original;
        const { accrualEntityIds, isLoadingAccrualLedgers } =
            useAccrualAwareTableMeta<InvoicesViewCallbacks, Invoice>(table);

        return (
            <ViewTableCell>
                {isLoadingAccrualLedgers ? (
                    "-"
                ) : (
                    <Amount
                        amount={getInvoicePaidAmount(invoice, accrualEntityIds)}
                    />
                )}
            </ViewTableCell>
        );
    },
);
